import PublicTopNav from "@/components/paw/PublicTopNav";
import SiteFooter from "@/components/paw/SiteFooter";

export default function ComingSoonPage() {
  return (
    <div
      data-testid="coming-soon-page"
      style={{
        width: "100%",
        minHeight: "100vh",
        margin: 0,
        padding: 0,
        background: "#F7F3EA",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <PublicTopNav />

      <main className="block w-full md:hidden" style={{ flex: "1 1 auto" }}>
        <img
          src="/mobile-coming-soon.webp"
          alt="Paw-some Reports Coming Soon"
          style={{ display: "block", width: "100%", height: "auto", margin: 0, padding: 0 }}
        />
        <div aria-hidden="true" style={{ height: "40px" }} />
      </main>

      <main
        className="hidden md:flex"
        style={{
          flex: "1 1 auto",
          minHeight: 0,
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <img
          src="/coming-soon.png"
          alt="Paw-some Reports Coming Soon"
          style={{
            display: "block",
            maxWidth: "100%",
            maxHeight: "100%",
            width: "auto",
            height: "auto",
            objectFit: "contain",
            margin: 0,
            padding: 0,
          }}
        />
      </main>

      <SiteFooter />
    </div>
  );
}
